export type ActionName = "new" | "edit" | "update" | "reset";

export const AVAILABLE_ACTIONS: ActionName[] = [
  "new",
  "edit",
  "update",
  "reset",
];

export type OnClickCallback = () => void;

export type Action = {
  name: ActionName;
  can: boolean;
  onClick: OnClickCallback;
};
